import React from "react";
import "./roadmap-new.css";

const Roadmap = () => {
    return (
        <div className="roadmap" id="roadmap">
            <div className="title-heading">
                <div>
                    <h2>
                        Our <span>Roadmap</span>
                    </h2>
                </div>
            </div>

            <div className="timeline">
                <ul>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 1</h2>
                            <p>
                            News breaks that the Legends of Shangu have awakened
                            and are coming to the Metaverse! An investment fund
                            has been created to finance the growth of our
                            community, marketing development, community wallet,
                            designs and creations.
                            </p>
                        </div>
                        <div className="left_content left-pos-top">
                            <h3>0%</h3>
                        </div>
                    </li>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 2</h2>
                            <p>
                            The first Legends of Shangu have been released into
                            the Metaverse via the Awakening sale! Only existing
                            Owners of David Huynh Art will be allowed into this
                            sale! The community is rock solid.
                            </p>
                        </div>
                        <div className="left_content">
                            <h3>20%</h3>
                        </div>
                    </li>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 3</h2>
                            <p>
                            Legends of Shangu breaks the news! We have launched
                            our legendary marketing campaign and have partnered
                            with some of the biggest names in the world to
                            further advance our marketing and community.
                            </p>
                        </div>
                        <div className="left_content">
                            <h3>40%</h3>
                        </div>
                    </li>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 4</h2>
                            <p>
                            Secure a digital real estate plot within Sandbox to
                            build the Legends Club and get Legends of Shangu
                            collection verified on opensea.io.
                            </p>
                        </div>
                        <div className="left_content">
                            <h3>50% </h3>
                        </div>
                    </li>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 5</h2>
                            <p>
                            Begin development for Legends of Shangu P2E game and
                            Token where holders will be able to stake their
                            NFT’s for tokens and rewards.
                            </p>
                        </div>
                        <div className="left_content">
                            <h3>70%</h3>
                        </div>
                    </li>
                    <li>
                        <div className="right_content">
                            <h2>STAGE 6</h2>
                            <p>
                            Initiation of project 2 with David Huynh! Upon sell out of project 1 we will initiate our Main Giveaway Raffle and launch a limited edition Legends of Shangu merch line exclusively for holders to purchase.
                            </p>
                        </div>
                        <div className="left_content left-pos">
                            <h3>100%</h3>
                        </div>
                    </li>
                    
                    <div style={{"clear":"both"}}></div>
                </ul>
            </div>
        </div>
    );
};

export default Roadmap;
